export class Benachrichtigung {
    bb_id: number;
    gruppe_id: number;
    tierliste_id: number;
    buchungs_id: number;
    ticket_id: number;
    typ: string;
    txt: string;
    titel: string;
    erstellt: Date;
    gelesen: number;
    gt_id: number;
    ohrmarke_notnull: string;
}

export class BenachrichtigungInfo {
    popup: number;
    ungelesen: number;
}
